module.exports = __webpack_public_path__ + "static/media/microsoft.4a068616.svg";